import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
var __jsx = React.createElement;
import React from "react";
import Head from "next/head";
import AllSlots from "components/new-games/AllSlots";
var GamesPage = function GamesPage() {
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, "WRewards - Games")), __jsx(AllSlots, null));
};
export var __N_SSP = true;
export default _withSuperJSONPage(GamesPage);